import { FC } from 'react';

import { Button, Sheet, Text } from '@betterment/samba-react';

import { pluralize } from '../../../../../utils/strings/strings';

export const BaseNumClients: FC<{ numClients: string }> = ({ numClients }) => (
  <Text variant="text100" aria-label="billingPlanNumClients">
    {numClients}
  </Text>
);

const ClientsAssigned: FC<{ numClients: string }> = ({ numClients }) => (
  <Sheet.Trigger asChild={true}>
    <Button variant="textPrimary" data-testid="viewClientsButton">
      <BaseNumClients numClients={numClients} />
    </Button>
  </Sheet.Trigger>
);

export const NumberOfClients: FC<{ numClients: number }> = ({ numClients }) => {
  const pluralizedNumClients = pluralize(numClients, 'client');

  return numClients > 0 ? (
    <ClientsAssigned numClients={pluralizedNumClients} />
  ) : (
    <BaseNumClients numClients={pluralizedNumClients} />
  );
};
